import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import {CountdownCircleTimer} from 'react-countdown-circle-timer';
import {useDispatch} from 'react-redux';
import {navigateNext} from '../../action/actions';
import Button from './Button';
import {publicBuildUrl} from '../../config/config';
import Api from "../../util/api";

const fancyTimeFormat = (duration) => {
    const mins = ~~((duration % 3600) / 60);
    const secs = ~~duration % 60;

    let ret = '';
    ret += '0' + mins + ':' + (secs < 10 ? '0' : '');
    ret += '' + secs;

    return ret;
}

const Tick = ({angle}) => (
    <div style={{
        ...styles.clockTickContainer,
        transform: 'rotate(' + angle + 'deg)',
    }}>
        <div className={'timerAnimatedColor'} style={styles.clockTick}/>
    </div>
);

Tick.propTypes = {
    angle: PropTypes.number.isRequired,
};

const GameTimer = ({seconds = 120, text}) => {
    const [isPlaying, setIsPlaying] = useState(false);

    const dispatch = useDispatch();

    const handleOnComplete = () => {
        Api.navigateDeviceNext().then(
            () => dispatch(navigateNext())
        );
    }

    const handleStartPlaying = () => {
        if (window.$) {
            window.$('.timerAnimatedColor').css('animation', 'none');
            window.$('.timerAnimatedColor').css('animation', '');
        }
        setIsPlaying(true);
        Api.navigateDeviceNext().then();
    }

    const renderTime = (props) => {
        const {elapsedTime, remainingTime} = props;
        const percentage = ((seconds - elapsedTime) / seconds) * 100;
        const invertPercentage = ((100 - percentage) * 3.6) + 90;

        return (
            <div>
                <Tick angle={0}/>
                <Tick angle={45}/>
                <Tick angle={90}/>
                <Tick angle={135}/>
                <Tick angle={180}/>
                <Tick angle={225}/>
                <Tick angle={270}/>
                <Tick angle={315}/>
                <div style={{
                    ...styles.clockWandContainer,
                    transform: 'rotate(' + invertPercentage + 'deg)',
                }}>
                    <div className={'timerAnimatedColor'} style={styles.clockWand}/>
                </div>

                {remainingTime !== 0 &&
                <div className='timer' style={{position: 'absolute', left: '220px', top: '25px'}}>
                    {isPlaying && <div className='value' style={styles.timer}>{fancyTimeFormat(remainingTime)}</div>}
                    {!isPlaying && <div style={{marginTop: '25px', width: '240px'}}>
                        <Button onClick={handleStartPlaying} color={'pink'} text={'Start het spel'}/>
                    </div>}
                </div>}
            </div>
        );
    }

    return (
        <Page title={'Target Group Selection'}>
            <div className={'bodyContainer'}>
                <div className={'bodyContainerColumn'} style={{display: 'flex', flexDirection: 'column'}}>
                    <img src={`${publicBuildUrl}images/MiroPlay.png`} alt={'Game time!'}/>
                </div>
                <div className={'bodyContainerColumn'}>
                    <div style={{width: '100%'}}>
                        <div style={styles.title}>SPEEL HET SPEL!</div>
                        <div style={styles.text}>
                            {text}
                        </div>
                        <div style={{position: 'relative'}}>
                            <CountdownCircleTimer
                                isPlaying={isPlaying}
                                duration={seconds}
                                colors={[
                                    ['#228D83', .5],
                                    ['#e4195f', .5],
                                ]}
                                onComplete={handleOnComplete}
                            >
                                {renderTime}
                            </CountdownCircleTimer>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    );
}

const styles = {
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '48px',
        lineHeight: '48px',
        fontStyle: 'italic',
        paddingBottom: '25px',
        marginBottom: '25px',
        width: '100%',
    },
    text: {
        fontSize: '24px',
        textAlign: 'center',
        marginBottom: '60px',
    },
    clockTickContainer: {
        position: 'absolute',
        height: '140px',
        width: '140px',
        left: 20,
        top: 20,
        display: 'flex',
        alignItems: 'center',
    },
    clockTick: {
        borderRadius: 5,
        width: '14px',
        height: '4px',
    },
    clockWandContainer: {
        position: 'absolute',
        height: '140px',
        width: '140px',
        left: 20,
        top: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    clockWand: {
        borderRadius: 5,
        width: '36px',
        height: '4px',
        marginLeft: '-25px',
    },
    timer: {
        color: '#e4195f',
        fontFamily: 'Ubuntu',
        fontStyle: 'italic',
        fontWeight: 'bold',
        fontSize: '105px',
        lineHeight: '105px',
    }
}

export default GameTimer;
